var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 22.6032V10.7302C22 10.5133 21.9548 10.2994 21.868 10.1055C21.7812 9.91152 21.6552 9.74281 21.5 9.6127L12.75 2.27936C12.5336 2.09803 12.2705 2 12 2C11.7295 2 11.4664 2.09803 11.25 2.27936L2.5 9.6127C2.34476 9.74281 2.21875 9.91152 2.13197 10.1055C2.04518 10.2994 2 10.5133 2 10.7302V22.6032C2 22.9736 2.1317 23.3289 2.36612 23.5909C2.60054 23.8528 2.91848 24 3.25 24H8.25C8.58152 24 8.89946 23.8528 9.13388 23.5909C9.3683 23.3289 9.5 22.9736 9.5 22.6032V18.4127C9.5 18.0422 9.6317 17.6869 9.86612 17.425C10.1005 17.163 10.4185 17.0159 10.75 17.0159H13.25C13.5815 17.0159 13.8995 17.163 14.1339 17.425C14.3683 17.6869 14.5 18.0422 14.5 18.4127V22.6032C14.5 22.9736 14.6317 23.3289 14.8661 23.5909C15.1005 23.8528 15.4185 24 15.75 24H20.75C21.0815 24 21.3995 23.8528 21.6339 23.5909C21.8683 23.3289 22 22.9736 22 22.6032Z",
    stroke: "url(#paint0_linear_1332_28369)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1332_28369",
    x1: 2.6,
    y1: 3.02667,
    x2: 22.2512,
    y2: 21.0243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9E8A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335083,
    stopColor: "#E6745A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678481,
    stopColor: "#A6708E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8490A8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeActive);
export default __webpack_public_path__ + "static/media/homeActive.dcf0423f503f8b6f3aeb65ce9897aa90.svg";
export { ForwardRef as ReactComponent };